import Utils from './tools';

export default {
  get: (keyName, url) => {
    const urlStr = url || window.location.href;
    const name = keyName.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(urlStr);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  getParams: (url) => {
    const params = {};
    const search = url.split('?')[1];
    if (search) {
      const parts = search.split('&');
      for (let i = 0; i < parts.length; i += 1) {
        const nv = parts[i].split('=');
        if (nv[0]) {
          let res = '';
          if (nv[1]) {
            // 转义字符
            res = decodeURIComponent(nv[1]);
          }
          params[nv[0]] = res || true;
        }
      }
    }
    return params;
  },
  // 飞猪链接
  parseVueRouterLink(url) {
    const hashParams = {};
    const queryParams = {};

    // 解析哈希参数
    const hashMatch = url.match(/#.*\?(.*)/);
    if (hashMatch && hashMatch[1]) {
      const hashString = hashMatch[1];
      const hashSearchParams = new URLSearchParams(hashString);

      hashSearchParams.forEach((value, key) => {
        hashParams[key] = value;
      });
    }

    // 解析查询参数
    const searchMatch = url.match(/\?(.*)#/);
    if (searchMatch && searchMatch[1]) {
      const searchString = searchMatch[1];
      const searchParams = new URLSearchParams(searchString);

      searchParams.forEach((value, key) => {
        queryParams[key] = value;
      });
    }

    return { hashParams, queryParams };
  },
  replace: (paramName, replaceWith, url) => {
    const oUrl = url || window.location.href.toString();
    const re = new RegExp(`${paramName}=[^&]*`, 'gi');

    let nUrl;

    if (replaceWith === undefined || replaceWith === null || replaceWith === '') {
      nUrl = oUrl.replace(re, '');
    } else {
      nUrl = oUrl.replace(re, `${paramName}=${replaceWith}`);
    }

    return nUrl.replace(/\?$/, '');
  },
  remove: (keyName, url) => {
    if (window.history && window.history.replaceState) {
      const urlStr = url || window.location.href;
      window.history.replaceState(null, null, Utils.removeParams(keyName, urlStr));
    }
  },

  add: (url, params) => {
    let newUrl = url;
    Object.keys(params).forEach((key) => {
      if (params[key] === undefined || params[key] === null) {
        return;
      }
      if (newUrl.indexOf('?') > newUrl.indexOf('#')) { // 已经有query并且属于hash中的, 或者仅有query
        newUrl = `${newUrl}&${key}=${encodeURIComponent(params[key])}`;
      } else {
        newUrl = `${newUrl}?${key}=${encodeURIComponent(params[key])}`;
      }
    });
    return newUrl;
  },
};
